import {
  AcademicCapIcon,
  BeakerIcon,
  BoltIcon,
  BookmarkIcon,
  BookOpenIcon,
  BriefcaseIcon,
  BuildingOfficeIcon,
  BuildingStorefrontIcon,
  CakeIcon,
  CalculatorIcon,
  CameraIcon,
  ChartBarIcon,
  CheckBadgeIcon,
  ClipboardDocumentListIcon,
  ClockIcon,
  CodeBracketIcon,
  CommandLineIcon,
  ComputerDesktopIcon,
  CurrencyDollarIcon,
  DocumentTextIcon,
  FaceSmileIcon,
  FilmIcon,
  FireIcon,
  FlagIcon,
  FolderIcon,
  GiftIcon,
  GlobeAltIcon,
  HeartIcon,
  KeyIcon,
  LanguageIcon,
  LifebuoyIcon,
  LightBulbIcon,
  LinkIcon,
  MapIcon,
  MapPinIcon,
  MegaphoneIcon,
  MicrophoneIcon,
  MoonIcon,
  MusicalNoteIcon,
  NewspaperIcon,
  PaintBrushIcon,
  PhotoIcon,
  PresentationChartLineIcon,
  PuzzlePieceIcon,
  ReceiptPercentIcon,
  RocketLaunchIcon,
  ShieldCheckIcon,
  ShoppingBagIcon,
  SparklesIcon,
  Square3Stack3DIcon,
  StarIcon,
  SunIcon,
  SwatchIcon,
  TagIcon,
  TicketIcon,
  TrophyIcon,
  TruckIcon,
  VideoCameraIcon,
  ViewfinderCircleIcon,
  WrenchIcon,
} from '@heroicons/react/24/outline';
// Ids are stored on content pages, so they stay stable across icon-set changes.
// Nothing that reads as member navigation (Home feed, Members, Events, messages, notifications,
// search, newsletter / podcast channels) or as access (locks): a page would look like a nav entry.
export const PAGE_ICONS = [
  {
    id: 'graduation-cap',
    Icon: AcademicCapIcon,
    name: 'Graduation cap',
    keywords: 'course school learn education class',
  },
  { id: 'book-open', Icon: BookOpenIcon, name: 'Book', keywords: 'read guide ebook library' },
  { id: 'video', Icon: VideoCameraIcon, name: 'Video', keywords: 'camera film tutorial recording' },
  { id: 'percent', Icon: ReceiptPercentIcon, name: 'Discount', keywords: 'receipt deal coupon offer sale' },
  { id: 'file-text', Icon: DocumentTextIcon, name: 'Document', keywords: 'file pdf text notes' },
  { id: 'lightbulb', Icon: LightBulbIcon, name: 'Light bulb', keywords: 'idea tips inspiration' },
  { id: 'rocket', Icon: RocketLaunchIcon, name: 'Rocket', keywords: 'launch start growth' },
  { id: 'star', Icon: StarIcon, name: 'Star', keywords: 'favourite featured best' },
  { id: 'award', Icon: CheckBadgeIcon, name: 'Badge', keywords: 'award verified certificate check' },
  { id: 'mic', Icon: MicrophoneIcon, name: 'Microphone', keywords: 'podcast audio talk' },
  { id: 'camera', Icon: CameraIcon, name: 'Camera', keywords: 'photo photography' },
  { id: 'music', Icon: MusicalNoteIcon, name: 'Music', keywords: 'song audio note playlist' },
  { id: 'gift', Icon: GiftIcon, name: 'Gift', keywords: 'present perk reward bonus' },
  { id: 'store', Icon: BuildingStorefrontIcon, name: 'Store', keywords: 'shop products storefront' },
  { id: 'heart', Icon: HeartIcon, name: 'Heart', keywords: 'love favourite like' },
  { id: 'zap', Icon: BoltIcon, name: 'Lightning', keywords: 'bolt fast energy power' },
  { id: 'target', Icon: ViewfinderCircleIcon, name: 'Target', keywords: 'goal focus aim' },
  { id: 'trophy', Icon: TrophyIcon, name: 'Trophy', keywords: 'win award prize challenge' },
  { id: 'bookmark', Icon: BookmarkIcon, name: 'Bookmark', keywords: 'save reading list' },
  { id: 'folder', Icon: FolderIcon, name: 'Folder', keywords: 'files resources library' },
  { id: 'layers', Icon: Square3Stack3DIcon, name: 'Layers', keywords: 'stack collection templates' },
  { id: 'compass', Icon: MapIcon, name: 'Map', keywords: 'travel guide directions' },
  { id: 'globe', Icon: GlobeAltIcon, name: 'Globe', keywords: 'world travel international web' },
  { id: 'newspaper', Icon: NewspaperIcon, name: 'Newspaper', keywords: 'news articles posts' },
  { id: 'megaphone', Icon: MegaphoneIcon, name: 'Megaphone', keywords: 'announcements marketing' },
  { id: 'link', Icon: LinkIcon, name: 'Link', keywords: 'url web resources' },
  { id: 'puzzle', Icon: PuzzlePieceIcon, name: 'Puzzle', keywords: 'games plugins' },
  { id: 'briefcase', Icon: BriefcaseIcon, name: 'Briefcase', keywords: 'work jobs business career' },
  { id: 'dollar', Icon: CurrencyDollarIcon, name: 'Dollar', keywords: 'money finance pricing' },
  { id: 'chart', Icon: ChartBarIcon, name: 'Chart', keywords: 'stats analytics data' },
  { id: 'presentation', Icon: PresentationChartLineIcon, name: 'Presentation', keywords: 'slides webinar deck growth' },
  { id: 'clipboard', Icon: ClipboardDocumentListIcon, name: 'Checklist', keywords: 'clipboard tasks list' },
  { id: 'shopping-bag', Icon: ShoppingBagIcon, name: 'Shopping bag', keywords: 'shop merch buy' },
  { id: 'tag', Icon: TagIcon, name: 'Tag', keywords: 'label price' },
  { id: 'ticket', Icon: TicketIcon, name: 'Ticket', keywords: 'event pass admission' },
  { id: 'photo', Icon: PhotoIcon, name: 'Image', keywords: 'photo picture gallery' },
  { id: 'film', Icon: FilmIcon, name: 'Film', keywords: 'movie cinema video' },
  { id: 'paint-brush', Icon: PaintBrushIcon, name: 'Paint brush', keywords: 'art design creative' },
  { id: 'swatch', Icon: SwatchIcon, name: 'Swatch', keywords: 'colours palette design' },
  { id: 'sparkles', Icon: SparklesIcon, name: 'Sparkles', keywords: 'new magic ai special' },
  { id: 'fire', Icon: FireIcon, name: 'Fire', keywords: 'hot trending popular' },
  { id: 'sun', Icon: SunIcon, name: 'Sun', keywords: 'summer weather day' },
  { id: 'moon', Icon: MoonIcon, name: 'Moon', keywords: 'night sleep' },
  { id: 'cake', Icon: CakeIcon, name: 'Cake', keywords: 'birthday celebration food' },
  { id: 'face-smile', Icon: FaceSmileIcon, name: 'Smile', keywords: 'fun happy emoji' },
  { id: 'building', Icon: BuildingOfficeIcon, name: 'Office', keywords: 'company building business' },
  { id: 'map-pin', Icon: MapPinIcon, name: 'Location', keywords: 'place pin local city' },
  { id: 'flag', Icon: FlagIcon, name: 'Flag', keywords: 'milestone country report' },
  { id: 'key', Icon: KeyIcon, name: 'Key', keywords: 'access password unlock' },
  { id: 'shield', Icon: ShieldCheckIcon, name: 'Shield', keywords: 'security safety privacy' },
  { id: 'wrench', Icon: WrenchIcon, name: 'Wrench', keywords: 'tools settings fix' },
  { id: 'beaker', Icon: BeakerIcon, name: 'Beaker', keywords: 'science lab experiment' },
  { id: 'code', Icon: CodeBracketIcon, name: 'Code', keywords: 'developer programming brackets' },
  { id: 'terminal', Icon: CommandLineIcon, name: 'Terminal', keywords: 'command line developer' },
  { id: 'clock', Icon: ClockIcon, name: 'Clock', keywords: 'time schedule hours' },
  { id: 'calculator', Icon: CalculatorIcon, name: 'Calculator', keywords: 'maths numbers budget' },
  { id: 'computer', Icon: ComputerDesktopIcon, name: 'Computer', keywords: 'desktop screen tech' },
  { id: 'language', Icon: LanguageIcon, name: 'Language', keywords: 'translate languages' },
  { id: 'lifebuoy', Icon: LifebuoyIcon, name: 'Lifebuoy', keywords: 'help support faq' },
  { id: 'truck', Icon: TruckIcon, name: 'Truck', keywords: 'shipping delivery logistics' },
];

export const searchPageIcons = (query: string) => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return PAGE_ICONS;

  return PAGE_ICONS.filter(({ name, keywords }) => `${name} ${keywords}`.toLowerCase().includes(normalizedQuery));
};

export const getPageIcon = (icon: string) => PAGE_ICONS.find((option) => option.id === icon)?.Icon ?? FolderIcon;
